import { render, staticRenderFns } from "./FiltersPopup.vue?vue&type=template&id=0b917b80&scoped=true&"
import script from "./FiltersPopup.vue?vue&type=script&lang=js&"
export * from "./FiltersPopup.vue?vue&type=script&lang=js&"
import style0 from "./FiltersPopup.vue?vue&type=style&index=0&id=0b917b80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b917b80",
  null
  
)

export default component.exports